import { IAdpDonor } from '@nkr/models/index';
import { AdpVoucherPrintStatus } from '@nkr/enums/index';
import VoucherHolderRow from './voucher-holder-row';
import DonationTypeRenderer from './render-donation-type';

interface IProps {
    donor: IAdpDonor,
    userId: number,
    status: number,
    onDonorAction: (donorId: number, currentPrintStatus: AdpVoucherPrintStatus) => void,
    onVoucherHolderAction: (voucherHolderId: number, currentPrintStatus: AdpVoucherPrintStatus) => void
}

const DonorRow = (props: IProps) => {
    const handleDonorAction = () => {
        let { id, printStatus } = props.donor;
        props.onDonorAction(id, printStatus);
    };

    const renderDonorActionButton = () => {
        var buttonWidth: number = 150;
        var hasAlreadyClickedMarkSent1 = props.donor.adpCertFirstCheckUserId == props.userId;

        if (props.donor.hasDonated == false) {
            return null;
        }

        switch (props.donor.printStatus) {
            case AdpVoucherPrintStatus.ReadyToPrint:
                return <button className='btn btn-xs btn-success' onClick={handleDonorAction} style={{ width: buttonWidth }}>Print Certificate</button>;

            case AdpVoucherPrintStatus.Printed:
                return <button className='btn btn-xs btn-primary' onClick={handleDonorAction} style={{ width: buttonWidth }}>User 1 - Mark Sent</button>;

            case AdpVoucherPrintStatus.MarkSentUser1:
                return <button className='btn btn-xs btn-warning' onClick={handleDonorAction} style={{ width: buttonWidth }} disabled={hasAlreadyClickedMarkSent1}>User 2 - Mark Sent</button>;

            case AdpVoucherPrintStatus.MarkSentUser2:
                return <button className='btn btn-xs btn-secondary' style={{ width: buttonWidth }} disabled>Sent</button>;
        }
    }

    const { donor, userId } = props;

    const voucherHolders = donor.voucherHolders.filter(x => {
        if (props.status == 2) {
            return x.printStatus == AdpVoucherPrintStatus.ReadyToPrint;
        }

        if (props.status == 4) {
            return x.printStatus == AdpVoucherPrintStatus.MarkSentUser2;
        }

        return true;
    });

    return (
        <>
            <tr>
                <td style={{ textAlign: 'center' }}><DonationTypeRenderer donationType={donor.donationType} donationTypeAbbr={donor.donationTypeAbbr} /></td>
                <td style={{ textAlign: 'center' }}>{donor.alias}</td>
                <td style={{ textAlign: 'center' }}>{donor.donationDate}</td>
                <td style={{ textAlign: 'center' }}>{donor.registrationDate}</td>
                <td style={{ textAlign: 'center' }}>-</td>
                <td style={{ textAlign: 'center' }}>{donor.name}</td>
                <td style={{ textAlign: 'center' }}>-</td>
                <td style={{ textAlign: 'center' }}>-</td>
                <td style={{ textAlign: 'center' }}> {renderDonorActionButton()}</td>
            </tr>

            {voucherHolders.map((voucherHolder, index) =>
                <VoucherHolderRow
                    key={index}
                    voucherHolder={voucherHolder}
                    userId={userId}
                    onVoucherHolderAction={props.onVoucherHolderAction}
                />
            )}
        </>
    );
}

export default DonorRow;